import environment from "@/settings/environment";
import { FormattedDebts } from "./transform";

export const validatePhone = (telefone: string) => {
    telefone = telefone?.replace(/\D/g, '');

    if (!(telefone?.length >= 10 && telefone?.length <= 11)) return false;

    if (telefone?.length == 11 && parseInt(telefone?.substring(2, 3)) != 9) return false;

    for (let n = 0; n < 10; n++) {
        if (telefone == new Array(11).join(n.toString()) || telefone == new Array(12).join(n.toString())) return false;
    }
    const codigosDDD = [11, 12, 13, 14, 15, 16, 17, 18, 19,
        21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46,
        47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73,
        74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95,
        96, 97, 98, 99];
    if (codigosDDD.indexOf(parseInt(telefone?.substring(0, 2))) == -1) return false;

    if (telefone?.length == 10 && [2, 3, 4, 5, 7].indexOf(parseInt(telefone.substring(2, 3))) == -1) return false;

    return true;
};

export const validateEmail = (email: string) => {
    return /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/.test(email)
}

export function validateCPF(input: string) {
    const strCPF = input?.replace('.', '')?.replace('.', '')?.replace('-', '');
    let Soma;
    let Resto;
    Soma = 0;

    if (
        input === '000.000.000-00' ||
        input === '111.111.111-11' ||
        input === '222.222.222-22' ||
        input === '333.333.333-33' ||
        input === '444.444.444-44' ||
        input === '555.555.555-55' ||
        input === '666.666.666-66' ||
        input === '777.777.777-77' ||
        input === '888.888.888-88' ||
        input === '999.999.999-99'
    )
        return false;
    if (strCPF?.length !== 11) {
        return false;
    }

    for (let i = 1; i <= 9; i++) {
        Soma += parseInt(strCPF?.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;
    }

    if (Resto === 10 || Resto === 11) {
        Resto = 0;
    }

    if (Resto != parseInt(strCPF?.substring(9, 10))) {
        return false;
    }
    Soma = 0;

    for (let i = 1; i <= 10; i++) {
        Soma += parseInt(strCPF?.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;
    }

    if (Resto === 10 || Resto === 11) {
        Resto = 0;
    }

    if (Resto != parseInt(strCPF?.substring(10, 11))) {
        return false;
    }
    return true;
}

export function validateCNPJ(input: string) {
    const cleanCNPJ = input?.replace(/\./g, '')?.replace(/\-/g, '')?.replace(/\//g, '');

    if (
        input === '00.000.000/0000-00' ||
        input === '11.111.111/1111-11' ||
        input === '22.222.222/2222-22' ||
        input === '33.333.333/3333-33' ||
        input === '44.444.444/4444-44' ||
        input === '55.555.555/5555-55' ||
        input === '66.666.666/6666-66' ||
        input === '77.777.777/7777-77' ||
        input === '88.888.888/8888-88' ||
        input === '99.999.999/9999-99'
    )
        return false;
    
    if (cleanCNPJ?.length !== 14) {
        return false;
    }

    let size = cleanCNPJ.length - 2;
    let numbers = cleanCNPJ.substring(0, size);
    let digits = cleanCNPJ.substring(size);
    let sum = 0;
    let pos = size - 7;

    for (let i = size; i >= 1; i--) {
        sum += parseInt(numbers.charAt(size - i)) * pos--;
        if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result != parseInt(digits.charAt(0))) return false;

    size = size + 1;
    numbers = cleanCNPJ.substring(0, size);
    sum = 0;
    pos = size - 7;

    for (let i = size; i >= 1; i--) {
        sum += parseInt(numbers.charAt(size - i)) * pos--;
        if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - sum % 11;
    if (result != parseInt(digits.charAt(1))) return false;

    return true;
}

export function clearString(value: string) {
    return value
      .toString()
      .replace(/\./g, '')
      .replace(/\-/g, '')
      .replace(/\//g, '')
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/\ /g, '')
      .replace(/\ /g, '');
}

export function getIsValidString(value?: string | unknown) {
    if (typeof value === "string" && value !== "") return true;
    return false;
}

export const getFormattedCart = ({
    debts,
    cart,
}: {
    debts: FormattedDebts[];
    cart: { 
        name: string;
    }[];
}) => {
    const filteredDebts = debts?.filter(debt =>
        cart?.some(cartItem => cartItem.name === debt.id)
    );

    const total = filteredDebts?.reduce(
        (sum: number, item) => sum + Number(item?.price.replace(/,/g, '.')),
        0
    );

    const selected = filteredDebts?.map(item => item.id);

    return {
        selected,
        total: Number(total?.toFixed(2)),
        filteredItems: filteredDebts,
    };
};

export const getFirstAndLastName = (fullName: string) => {
    const nameParts = fullName?.trim()?.split(' ');
    const firstName = nameParts?.[0] ?? "";
    const lastName = nameParts?.[1] ?? "";
    return { firstName, lastName };
}

export const openApp = (platform: "ios" | "android") => {
    const uri = platform === "ios" ? 
            "https://apps.apple.com/us/app/id6737811254" :
            "https://play.google.com/store/apps/details?id=br.com.freeflow";
    const win = window.open(uri, '_blank');
    win?.focus();
}

export const getIsAppleDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /mac|iphone|ipad|ipod/.test(userAgent);
}

export const getFormattedValue = (value: string | number) => {
    return `R$ ${Number(value ?? 0).toFixed(2).toString().replace(/\./g, ',')}`
}

export const vehicleTypes = [
    {
      text: 'Moto',
      value: 'motorcycle',
      description: "Triciclo|Motoneta|CicloMotor|Motocicleta",
      id: 5,
    },
    {
      text: 'Passeio',
      value: 'car',
      description: 'Automovel',
      id: 1,
    },
    {
      text: 'Utilitário',
      value: 'bigCar',
      description: 'Caminhonete|Utilitario|Camioneta',
      id: 2,
    },
    {
      text: 'Ônibus / Micro Ônibus',
      value: 'bus',
      description: "Micro Onibus|Onibus",
      id: 3,
    },
    {
      text: 'Caminhão / Carreta',
      value: 'truck',
      description: "Caminhao",
      id: 4,
    },
];

export const getIsValidType = (type?: string) => {
    return !!type && !String(type)?.toLocaleLowerCase()?.includes('não') && !String(type)?.toLocaleLowerCase()?.includes('nao');
}

export const regexHaveNumber = /\d/;
export const regexHaveUppercase = /[A-ZÀ-Ü]/;
export const regexHaveLowerCase = /[a-zà-ü]/;

export const validatePassword = (password: string) => {
    if (password?.length < 8 || password?.length > 20) return false;
    if (!regexHaveLowerCase.test(password)) return false;
    if (!regexHaveUppercase.test(password)) return false;
    if (!regexHaveNumber.test(password)) return false;
    return true;
}

export const getCapitalizedWords = (value: string) => {
    return value?.split(' ')?.map(word =>
      word?.charAt(0)?.toUpperCase() + String(word?.slice(1))?.toLocaleLowerCase()
    ).join(' ');
}

export const getFormattedDeviceFingerPrintID = (id: string) => {
    return String(id ?? "")?.replace(
        environment.api.cybersource.merchantId,
        ''
    );
}

export function getCardType(number: string, descriptionFull = true) {
  if (!number) return false;
  number = number.replace(/\ /g, '');
  // visa
  let re = new RegExp('^4');
  if (number.match(re) != null) return 'visa';

  // Mastercard
  // Updated for Mastercard 2017 BINs expansion
  if (
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
      number
    )
  )
    return 'mastercard';

  // AMEX
  re = new RegExp('^3[47]');
  if (number.match(re) != null) return descriptionFull ? 'american-express' : 'amex';

  // Diners
  re = new RegExp('^3(?:0[0-5]|[68][0-9])[0-9]{11}');
  if (number.match(re) != null) return 'diners';

  // Diners - Carte Blanche
  re = new RegExp('^30[0-5]');
  if (number.match(re) != null) return 'diners';

  // Elo
  re = new RegExp(
    '^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))'
  );
  if (number.match(re) != null) return 'elo';

  // JCB
  re = new RegExp('^35(2[89]|[3-8][0-9])');
  if (number.match(re) != null) return 'jcb';

  // Visa Electron
  re = new RegExp('^(4026|417500|4508|4844|491(3|7))');
  if (number.match(re) != null) return 'visa';

  // Hipercard
  re = new RegExp('^606282|^637095|^637599|^637568');
  if (number.match(re) != null) return 'hipercard';

  return false;
}

export function getDocumentType(document: string): 'CPF' | 'CNPJ' | null {
    const cleanDocument = clearString(document);
    
    if (cleanDocument.length === 11) {
        return validateCPF(document) ? 'CPF' : null;
    } else if (cleanDocument.length === 14) {
        return validateCNPJ(document) ? 'CNPJ' : null;
    }
    
    return null;
}

export function isPJ(document: string): boolean {
    return getDocumentType(document) === 'CNPJ';
}